(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cryo-c-challenger-v1"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-ccv1-root]');
    if (!root) return;
    document.body.classList.add('ccv1-popup-suppressed');

    const suppressKlaviyoPopup = () => {
      document.querySelectorAll("div[role='dialog'][aria-modal='true']").forEach((dialog) => {
        if (!dialog.querySelector('form.klaviyo-form')) return;
        dialog.hidden = true;
        dialog.setAttribute('aria-hidden', 'true');
        dialog.style.setProperty('display', 'none', 'important');
      });
      document.querySelectorAll("[class*='kl-teaser']").forEach((teaser) => {
        teaser.style.setProperty('display', 'none', 'important');
      });
    };

    suppressKlaviyoPopup();
    new MutationObserver(suppressKlaviyoPopup).observe(document.body, {
      childList: true,
      subtree: true
    });

    const storageKey = 'wi_cc_challenger_attribution_v1';
    const allowedKeys = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'utm_term',
      'utm_id',
      'fbclid',
      'gclid',
      'gad_source',
      'campaign_id',
      'adset_id',
      'ad_id',
      'site_source_name',
      'placement'
    ];

    const readStored = () => {
      try {
        return JSON.parse(window.sessionStorage.getItem(storageKey) || '{}');
      } catch (error) {
        return {};
      }
    };

    const current = {};
    const search = new URLSearchParams(window.location.search);
    allowedKeys.forEach((key) => {
      const value = search.get(key);
      if (value) current[key] = value.slice(0, 500);
    });

    const attribution = { ...readStored(), ...current };
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(attribution));
    } catch (error) {
      Object.keys(attribution).forEach((key) => {
        if (!allowedKeys.includes(key)) delete attribution[key];
      });
    }

    const populateForm = (form) => {
      form.querySelectorAll('[data-ccv1-param]').forEach((input) => {
        input.value = attribution[input.dataset.ccv1Param] || '';
      });
      const landingUrl = form.querySelector('[data-ccv1-landing-url]');
      if (landingUrl) landingUrl.value = window.location.href.slice(0, 2000);
    };

    root.querySelectorAll('[data-ccv1-form]').forEach((form) => {
      populateForm(form);
      form.addEventListener('submit', () => {
        populateForm(form);
        const button = form.querySelector('[data-ccv1-submit]');
        const label = form.querySelector('[data-ccv1-button-label]');
        if (!button || button.disabled) return;
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
        if (label) label.textContent = button.dataset.loadingLabel;
      });
    });

    // Back/forward-cache restores the DOM mid-submit: re-arm any button this script disabled
    // (aria-busy marks ours; a sold-out disable never carries it).
    window.addEventListener('pageshow', () => {
      root.querySelectorAll('[data-ccv1-submit][aria-busy="true"]').forEach((button) => {
        button.removeAttribute('aria-busy');
        button.disabled = false;
        const label = button.querySelector('[data-ccv1-button-label]');
        if (label && button.dataset.defaultLabel) label.textContent = button.dataset.defaultLabel;
      });
    });

    const stage = root.querySelector('[data-ccv1-stage]');
    const stageCaption = root.querySelector('[data-ccv1-caption]');
    const thumbs = root.querySelectorAll('[data-ccv1-thumb]');
    if (stage && thumbs.length > 1) {
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          stage.src = thumb.dataset.full;
          if (thumb.dataset.srcset) stage.srcset = thumb.dataset.srcset;
          stage.alt = thumb.dataset.alt || '';
          if (stageCaption && thumb.dataset.caption) stageCaption.textContent = thumb.dataset.caption;
          thumbs.forEach((other) => {
            const active = other === thumb;
            other.classList.toggle('is-active', active);
            other.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
      });
      window.addEventListener('load', () => {
        thumbs.forEach((thumb) => {
          if (!thumb.classList.contains('is-active') && thumb.dataset.full) {
            new Image().src = thumb.dataset.full;
          }
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
